import angular from 'angular';
import EditProductComponent from './edit.component';

const editProductModule = angular.module('tinaba.components.menu.catalog.edit', [])

.component('editProduct', EditProductComponent);

export default editProductModule;



/** WEBPACK FOOTER **
 ** ./client/app/components/menu/catalog/edit/edit.js
 **/